import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setGameQualifyModalVisibleAction } from 'redux/actions/modal.action';
import { IProps, IState } from './types';
// import { TravelPlanType } from 'constants/enums/travelPlanType.enum';
import _ from 'lodash';
import { SysOptionReq, SysOption } from 'bff/models/info';
import { CodeId } from 'constants/enums/codeId.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import InsTypeDefines from 'constants/models/insTypeDefines';
import { InsType } from 'constants/enums/insType.enum';
// import { InsuredState, IFill2ndState } from 'constants/models/components/insurProcess/insureProcessFill2nd';
import { ApplyType } from 'constants/enums/applyType.enum';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import service from 'bff/services/travelProductService';
import apiCommonService from 'bff/services/commonService';
import commonService from 'utils/commonService';
import { SysOptParamId } from 'constants/enums/sysOptParamId.enum';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
import { PdfExportContent } from 'bff/models/product';
import { ExpType } from 'constants/enums/expType.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { PayerContent } from 'bff/models/member/boPayby';
import { PaymentMethod } from 'constants/enums/paymentMethod.enum';
import { GameChkqualifyResp } from 'bff/models/game/gameChkqualify';
import { GamePOI } from 'constants/enums/gamePOI.enum';
import gameService from 'bff/services/gameService';

class InsureProcessSuccess extends React.Component<IProps, IState> {
  state: IState = {
    emailNotifySysOpts: new Array(0),
    docIdSysOpts: new Array(0),
    policyDeliverySysOpts: new Array(0),
    applyType: ApplyType.WebInsured,
    barCodeUrl: ''
  }

  componentDidMount = async () => {
    commonService.scrollToTop();
    // PROD_ID = NTA 國外旅遊險、NTAG 申根保險，則 Lightbox 呈現 英文投保證明頁
    // const prodId = this.props.boPayby ? this.props.boPayby.PROD_ID : this.props.tempFill2nd.tempFill2ndState?.planData?.PROD_ID;

    // if (prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG) {
    //   if (this.props.boPayby) {
    //     this.props.setFillPassportModalVisible(
    //       true, this.props.boPayby.PAYER_LIST, this.props.boPayby.APPLY_NO);
    //   } else {
    //     this.props.setFillPassportModalVisible(
    //       true, this.props.tempFill2nd?.tempFill2ndFormVal?.INSUREDS, this.props.tempFill2nd.tempFill2ndState?.serialNo);
    //   }
    // }

    await this.handleFetchSysOpts();

    // 若繳費方式選擇行動條碼，且為網要時，取得繳費條碼路由
    const { tempPaymentFormVal } = this.props.tempPayment;
    const { tempFill2ndFormVal, tempFill2ndState } = this.props.tempFill2nd;
    let barCodeUrl = '';
    if (
      tempPaymentFormVal &&
      tempFill2ndFormVal &&
      tempFill2ndState &&
      tempFill2ndState.applyType === ApplyType.WebRequire &&
      tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BarCode) {
      barCodeUrl = await service.fetchBarcodeUrl(tempFill2ndState.serialNo || '', tempFill2ndFormVal.NAME);
    }

    // 補繳費
    if (
      tempPaymentFormVal &&
      tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BarCode &&
      this.props.boPayby &&
      this.props.boPayby.APPLY_NO
    ) {
      const policyholders =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

      barCodeUrl = await service.fetchBarcodeUrl(this.props.boPayby.APPLY_NO, policyholders[0].NAME);
    }

    // 若是以帳戶轉帳或信用卡支付且有要保號，走到此頁視為「已繳款」，則查詢抽獎資格
    if (
      tempFill2ndState &&
      tempFill2ndState.serialNo &&
      tempPaymentFormVal &&
      (tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BankAccount || tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.CreditCard)) {
      const _applyNo = tempFill2ndState.serialNo;
      const args = {
        GAMEPOI: GamePOI.INSURE,
        APPLY_NO: _applyNo
      };
      const response = await gameService.gameChkqualify(args);
      if (response && response.QUALIFIED_DCNT > 0) {
        // 顯示抽獎資格提示跳窗
        this.props.setGameQualifyModalVisible(true, GamePOI.INSURE, _applyNo, response);
      }
    }

    this.setState({
      barCodeUrl: barCodeUrl
    });

    // this.props.setFillPassportModalVisible(true, this.props.tempFill2nd?.tempFill2ndFormVal?.INSUREDS);
    // console.log('tempFill1', this.props.tempFill1st);
    // console.log('tempFill2', this.props.tempFill2nd);
    // console.log('tempState', JSON.stringify(this.props.tempState));
    // console.log('insCode', this.props.insDoneCode);
  }

  /**
   *@description 投保類型為網要 - B 時取得系統參數
   */
  handleFetchSysOpts = async () => {
    const applyType = this.props.boPayby ? this.props.boPayby.BC_TYPE : this.props.tempFill2nd.tempFill2ndState?.applyType as string;

    const sysOptionReq: SysOptionReq = {
      PCLASS: [SysOptType.EMAIL_NOTIFY, SysOptType.PODELIVERY]
    };

    if (applyType === ApplyType.WebRequire) {
      sysOptionReq.PCLASS.push(SysOptType.DOC_ID);
    }

    const res = await apiCommonService.fetchSysOpts(sysOptionReq);
    if (!res) return;
    // console.log('emailNotifySysOpts', commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.EMAIL_NOTIFY])));
    // console.log('docIdSysOpts', commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.DOC_ID])));
    this.setState({
      emailNotifySysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.EMAIL_NOTIFY])),
      docIdSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.DOC_ID])),
      policyDeliverySysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.PODELIVERY])),
      applyType: applyType
    });
  }

  /**
   * @description 取得網投完成訊息
   */
  handleWebInsuredSuccessMsg = () => {
    const { tempPaymentFormVal } = this.props.tempPayment;
    if (!tempPaymentFormVal) return;

    if (this.props.boPayby || (this.props.tempFill2nd && this.props.tempFill2nd.tempFill2ndFormVal)) {
      const insTypeId = this.props.boPayby ? this.props.boPayby.INS_TYPE_ID : this.props.tempFill2nd.tempFill2ndState?.planData?.INS_TYPE_ID;

      let applicantName = this.props.tempFill2nd?.tempFill2ndFormVal?.NAME;
      if (this.props.boPayby) {
        const applicant = _.find(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

        applicantName = applicant?.NAME;
      }

      let msg = '';
      if (tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BarCode) {
        msg = this.handleFormatBarMsg(CodeId.B001, moment().format('YYYY/MM/DD HH:mm'), InsTypeDefines[insTypeId as InsType]);
      }

      if (!msg) {
        msg = this.handleFormatMsg(CodeId.B001, moment().format('YYYY/MM/DD HH:mm'), InsTypeDefines[insTypeId as InsType]);
      }

      return (
        <p>
          {`親愛的${applicantName}您好：`}<br />
          <span>{commonService.htmlParser(msg)}</span>
        </p>
      );
    }
  }

  /**
   * @description 取得網要投保完成訊息
   */
  handleWebRequireSuccessMsg = () => <p>{commonService.htmlParser(this.handleFormatMsg(CodeId.B002))}</p>;

  /**
   * @description 取得投保完成訊息3
   */
  handleSuccessMsg4th = () => {
    const msg = this.handleGetSysMsg(this.state.emailNotifySysOpts, SysOptParamId.EMAIL_NOTIFY_CUSTOM_SERVICE);
    if (!msg) return null;

    let msgInfo: any = msg;

    if (msg.indexOf('：') !== -1) {
      const msgArray = msg.split('：');

      msgInfo = _.map(msgArray, (msg: string, index: number) => {
        return React.cloneElement(
          <>
            {msg} <br />
          </>
          , { key: index });
      });
    }

    return <p>{msgInfo}</p>;
  }

  /**
   *@description 建立投保資訊區塊
   */
  handleCreateInsuredInfo = () => {
    if ((this.props.tempFill2nd && this.props.tempFill1st) || this.props.boPayby) {
      // const insuredRange = this.props.tempFill1st.tempFill1stFormVal?.INSURED_RANGE || new Array(0);
      const startDate = this.props.boPayby && this.props.boPayby.APPLY_NO
        ? moment(this.props.boPayby.START_DATE).format('YYYY/MM/DD')
        : moment(this.props.tempFill1st.tempFill1stFormVal?.START_DATE).format('YYYY/MM/DD');
      const endDate = this.props.boPayby && this.props.boPayby.APPLY_NO
        ? moment(this.props.boPayby.END_DATE).format('YYYY/MM/DD')
        : moment(this.props.tempFill1st.tempFill1stFormVal?.END_DATE).format('YYYY/MM/DD');

      const insuredTime = this.props.boPayby && this.props.boPayby.APPLY_NO
        ? this.props.boPayby.START_HOUR
        : moment(this.props.tempFill1st.tempFill1stFormVal?.INSURED_TIME).format('HH:00');
      const period = moment(endDate).diff(moment(startDate), 'd');

      const total = this.props.boPayby && this.props.boPayby.APPLY_NO
        ? `${this.props.boPayby.POLICY_FEE}`
        : this.props.tempFill2nd.tempFill2ndState?.planData?.HEADER?.TOTAL;

      const serialNo = this.props.boPayby && this.props.boPayby.APPLY_NO
        ? this.props.boPayby.APPLY_NO
        : this.props.tempFill2nd.tempFill2ndState?.serialNo;

      const insureds: any = this.props.boPayby && this.props.boPayby.APPLY_NO
        ? [...this.props.boPayby.PAYER_LIST]
        : this.props.tempFill2nd.tempFill2ndFormVal?.INSUREDS;

      const delivery = this.props.boPayby && this.props.boPayby.APPLY_NO
        ? this.props.boPayby.POLICY_DELIVERY
        : this.props.tempFill2nd.tempFill2ndFormVal?.DELIVERY;

      const deliveryType = delivery === PolicyDelivery.Electric
        ? SysOptParamId.EMAIL_NOTIFY_PODELIVER_EPAPER
        : SysOptParamId.EMAIL_NOTIFY_PODELIVER_PAPER;

      return (
        <>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">網路投保交易序號</div>
              <div className="element__list-group-content">{serialNo}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">被保險人姓名</div>
              <div className="element__list-group-content">{`${insureds[0].INSURED_NAME || insureds[0].NAME}等${insureds.length}人`}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保險期間</div>
              <div className="element__list-group-content">{`${startDate} ${insuredTime} ~ ${endDate} ${insuredTime}，共投保 ${period} 天`}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">交易金額</div>
              <div className="element__list-group-content">{`NT$ ${commonService.thousandFormat(total || '0')}`}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保單寄送方式</div>
              <div className="element__list-group-content">{`${this.handleGetDeliveryText(delivery || '')}:${this.handleGetSysMsg(this.state.emailNotifySysOpts, deliveryType)}`}</div>
            </div>
          </div>
        </>
      );
    }
  }

  /**
   * @description 下載要保書
   */
  handleDownload = async () => {
    if ((this.props.tempFill2nd && this.props.tempFill2nd.tempFill2ndState) || this.props.boPayby) {
      const serialNo = this.props.boPayby ? this.props.boPayby.APPLY_NO : this.props.tempFill2nd.tempFill2ndState?.serialNo;
      const prodId = this.props.boPayby ? this.props.boPayby.PROD_ID : this.props.tempFill2nd?.tempFill2ndState?.planData?.PROD_ID as string;
      const docId = this.handleGetSysMsg(this.state.docIdSysOpts, prodId);

      // console.log('serialNo', serialNo);
      // console.log('docId', docId);

      const applyFormReqContent: PdfExportContent = {
        APPLY_NO: serialNo || '',
        DOC_ID: docId || '',
        EXPTYPE: ExpType.OnlyRequire
      };

      const fileUrl = await service.downloadApplyForm(applyFormReqContent);
      if (fileUrl) {
        try {
          commonService.downloadFile(fileUrl, serialNo || '');
        } catch {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: '下載失敗',
            html: '無法取得相關資訊'
          });
        }
      }
    }
  }

  /**
   * @description 取得 CodeTable 訊息，替換對應區塊值
  */
  handleFormatMsg = (codeId: string, ...params: any) => {
    const msg = commonService.getCodeMsg(this.props.insDoneCode, codeId);
    if (!msg) return '';

    return this.handleGetMsgInfo(msg, ...params);
  }

  /**
 * @description 付款方式為代碼繳費 取得 CodeTable 訊息，替換對應區塊值
*/
  handleFormatBarMsg = (codeId: string, ...params: any) => {
    const msg = commonService.getCodeMsg(this.props.insDoneBarCode, codeId);
    if (!msg) return '';

    return this.handleGetMsgInfo(msg, ...params);
  }

  /**
  * @description 取得顯示文字
  */
  handleGetMsgInfo = (msg: string, ...params: any) => {
    if (params && params.length > 0) {
      for (let i = 0; i < params.length; i += 1) {
        msg = msg.replace(`{#PARAM${i + 1}}`, params[i]);
      }
    }

    return msg;
  }

  /**
   *@description 取得系統參數值
   */
  handleGetSysMsg = (sysOpts: SysOption[], paramId: string) => {
    return _.find(sysOpts, (sysOpt: SysOption) => sysOpt.PARAM_ID === paramId)?.PARAM_VALUE;
  }

  /**
   * @description 取得保單寄送方式文字
  */
  handleGetDeliveryText = (type: string) => {
    return _.find(this.state.policyDeliverySysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === type)?.PARAM_TEXT;
  }

  /**
   * @description 開新分頁至繳費頁
  */
  handleRedirectBarcodePage = async () => {
    if (!this.state.barCodeUrl) return;

    window.open(this.state.barCodeUrl);
  }

  render () {
    const { tempPaymentFormVal } = this.props.tempPayment;
    return (
      <div className="insure-process-success">
        <div className="insured-complete">
          <img src="https://ensureuat.wwunion.com/ensure/images/Ah_want_I01.png" alt="旅平險投保完成示意圖" width={250} />
          <div className="insured-complete__content">
            {
              this.state.applyType === ApplyType.WebInsured ? (
                <div className="insure-process-success__part">
                  {this.handleWebInsuredSuccessMsg()}
                </div>
              ) : null
            }
            {
              this.state.applyType === ApplyType.WebRequire ? (
                <div className="insure-process-success__part">
                  {this.handleWebRequireSuccessMsg()}
                </div>
              ) : null
            }
            {
              tempPaymentFormVal &&
              tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BarCode && (
                <div className="insure-process-success__part">
                  <p>{commonService.htmlParser(commonService.getCodeMsg(this.props.insDoneBarCode, CodeId.B003))}</p>
                </div>
              )
            }
          </div>
          {
            this.state.applyType === ApplyType.WebRequire &&
              tempPaymentFormVal &&
              tempPaymentFormVal.PAYMENT_METHOD !== PaymentMethod.BarCode
              ? (
                <div className="insured-complete__controls">
                  <button type="button" className="element__button element__button--red" onClick={this.handleDownload}>要保書下載</button>
                </div>
              ) : null
          }
          {
            this.state.applyType === ApplyType.WebRequire &&
              tempPaymentFormVal &&
              tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BarCode
              ? (
                <div className="insured-complete__controls">
                  <button type="button" className="element__button element__button--red" onClick={this.handleRedirectBarcodePage}>繳費單連結</button>
                </div>
              ) : null
          }
        </div>
        <div className="insurance-content">
          <div className="insurance-content__title">保險內容</div>
          <div className="insurance-content__content">
            <div className="element__list">
              {this.handleCreateInsuredInfo()}
              <div className="element__list-col">
                {
                  tempPaymentFormVal &&
                  tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BarCode && (
                    <div className="insure-process-success__part">
                      <p>{commonService.htmlParser(commonService.getCodeMsg(this.props.insDoneBarCode, CodeId.B004))}</p>
                    </div>
                  )
                }
                <div className="insure-process-success__part">
                  {this.handleSuccessMsg4th()}
                </div>
                {
                  tempPaymentFormVal &&
                  tempPaymentFormVal.PAYMENT_METHOD !== PaymentMethod.BarCode && (
                    <div className="insure-process-success__part">
                      <p>{commonService.htmlParser(commonService.getCodeMsg(this.props.insDoneCode, CodeId.B003))}</p>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

// const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  // setFillPassportModalVisible:
  //   (visible: boolean, insureds?: InsuredState[], serialNo?: string) =>
  //     dispatch(setFillPassportModalVisibleAction(visible, insureds, serialNo)),
  setGameQualifyModalVisible:
    (visible: boolean, gamePoi: string, applyNo: string, checkResult: GameChkqualifyResp) =>
      dispatch(setGameQualifyModalVisibleAction(visible, gamePoi, applyNo, checkResult))
});

export default connect(null, mapDispatchToProps)(InsureProcessSuccess);
